import React, { useState } from 'react';
import { Link } from 'react-router';
import { ArrowRight, BookOpen, Settings, Sparkles } from 'lucide-react';
import { getDailyPrayer, getDailyVerse, getLocalDailyDevotional } from '../services/dailyContentService';
import { getBibleReaderPath } from '../services/bibleReaderService';
import { BibleMark, DevotionalMark, PrayerMark } from './LauncherIcons';
import { track } from '../services/analytics';

const partOfDay = (date) => {
  const weekday = new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(date);
  const hour = date.getHours();
  return `${weekday} ${hour < 12 ? 'morning' : hour < 18 ? 'afternoon' : 'evening'}`;
};

export default function AppLauncher() {
  const [today] = useState(() => new Date());
  const verse = getDailyVerse(today);
  const prayer = getDailyPrayer(today);
  const devotional = getLocalDailyDevotional(today);
  const doors = [
    { to: '/prayer', tone: 'prayer', Mark: PrayerMark, title: 'Prayer', body: prayer.title, action: 'Pray today’s prayer' },
    { to: '/bible/reader', tone: 'bible', Mark: BibleMark, title: 'Bible', body: 'Open the Bible and read at your own pace.', action: 'Open the reader' },
    { to: '/devotionals', tone: 'devo', Mark: DevotionalMark, title: 'Devotional', body: devotional.title, action: 'Read today’s devotional' }
  ];

  return (
    <div className="vd-shell vd-launcher-shell">
      <main className="vd-launcher">
        <p className="vd-launcher-eyebrow">{partOfDay(today)}</p>
        <h1>A quiet moment for today.</h1>
        <p className="vd-launcher-sub">A prayer, a passage, a little space to reflect. Begin wherever you are.</p>

        <nav className="vd-launcher-tiles" aria-label="Choose a practice">
          {doors.map(({ to, tone, Mark, title, body, action }) => (
            <Link className="vd-launcher-tile" to={to} key={to} onClick={() => track('door_tapped', { door: title.toLowerCase() })}>
              <span className={`vd-launcher-mark is-${tone}`}><Mark /></span>
              <span className="vd-launcher-tile-copy">
                <strong>{title}</strong>
                <small>{body}</small>
                <span className="vd-daily-door-action">{action}</span>
              </span>
              <ArrowRight className="vd-launcher-tile-go" size={20} aria-hidden="true" />
            </Link>
          ))}
        </nav>

        <section className="vd-launcher-glimpse" aria-labelledby="vd-glimpse-heading">
          <header><BookOpen size={18} aria-hidden="true" /><h2 id="vd-glimpse-heading">Today’s verse</h2></header>
          <blockquote>“{verse.text}”</blockquote>
          <cite>{verse.reference} · World English Bible</cite>
          <div className="vd-daily-verse-links">
            <Link className="vd-launcher-glimpse-cta" to="/bible/verse-of-the-day">Reflect on today’s verse <ArrowRight size={16} aria-hidden="true" /></Link>
            <Link className="vd-launcher-glimpse-cta" to={getBibleReaderPath(verse.reference)}>Read the chapter</Link>
          </div>
        </section>

        <nav className="vd-daily-extras" aria-label="Optional tools">
          <Link to="/prayer/generate"><Sparkles size={16} aria-hidden="true" /> Create a personal prayer</Link>
          <Link to="/settings"><Settings size={16} aria-hidden="true" /> Settings &amp; verse delivery</Link>
        </nav>
        <nav className="vd-daily-utilities" aria-label="Your space">
          <Link to="/practice">My Practice</Link>
          <span aria-hidden="true">·</span>
          <Link to="/more">More tools &amp; resources</Link>
        </nav>
      </main>
    </div>
  );
}
